import usePrice from '@/lib/use-price';
import { useCart } from '@/store/quick-cart/cart.context';
import { getPromotionalPackDetails } from '@/store/quick-cart/cart.utils';
import { ISearchProduct } from '@/types';
import { useMemo } from 'react';

export const useProductPromotionalPack = (product: ISearchProduct) => {
  const { isInCart, isInStock } = useCart();

  const outOfStock = isInCart(product?.id) && !isInStock(product.id);

  const promotional_pack_details = useMemo(
    () => getPromotionalPackDetails(product),
    [product],
  );

  const disabledState =
    outOfStock ||
    product?.status?.toLowerCase() != 'publish' ||
    (promotional_pack_details.is_promotional_pack &&
      product.quantity! < (promotional_pack_details.promotional_pack_quantity ?? 0));

  const { price: promotional_pack_formatted_price } = usePrice({
    amount: promotional_pack_details.promotional_pack_unit_price as number,
  });

  return {
    promotional_pack_details,
    promotional_pack_formatted_price,
    disabledState,
  };
};
